import { gsap, Power1 } from 'gsap'
//import { gsap } from 'gsap/gsap-core'
import { breakpoint } from '../utilities/screen_setup'

let hero_video = $('#hero-video')
let moving_video = $('#hero-video video')
let windowWidth = breakpoint('full')

let drone = $(".drone-container img")
let tween
let sideView = windowWidth * 0.1
if(breakpoint('full') > breakpoint('lg') && document.getElementById('hero-video')){


  //gsap.set(cursorTarget, {xPercent: -50, yPercent: -50});


  let xPos = 0

  document.getElementById('hero-video').addEventListener('mousemove', event => {
    xPos = (event.clientX / windowWidth) - 0.5
    tween = gsap.to(moving_video, 1, {
      x: -xPos * sideView,
      //y: -yPos * heightView,
      ease: Power1.easeOut,
      force3D: false,
    });
    gsap.to(drone, 1, {
      rotationZ: xPos * 5,
      //y: -yPos * heightView,
      ease: Power1.easeOut,
      force3D: false,
    });
  });

}


function setupVideo(){

    if(moving_video.length) {

      let default_width = moving_video.width()
      let default_height = moving_video.height()
      let container_width = hero_video.width()
      let container_height = hero_video.height()
      let default_height_ratio = default_width / default_height
      let container_height_ratio = container_width / container_height

      if(default_height_ratio > container_height_ratio) {
        moving_video.css('height', '110%')
        moving_video.css('bottom', '5%')
      } else {
        moving_video.css('width', '110%')
        moving_video.css('left', '-5%')
      }

    }

}


setupVideo()
